module.exports = __webpack_public_path__ + "static/img/image1.9f537de1.png";